import React, { Component } from 'react'

import classNames from './Floating.css'

const MIN_WIDTH = 15 // %
const MAX_WIDTH = 45 // %

export default class Floating extends Component {
  static defaultProps = {
    options: {
      delay: 30,
      transition: 5
    }
  }
  state = {
    index: null,
    activeImages: []
  }
  componentDidMount () {
    this.mounted = true
    const { images, count, loadMoreImages, onFinish } = this.props
    if (images.length === 0) {
      if (count !== 0) {
        loadMoreImages().then(() => this.loadSlide(0, 0))
      } else {
        // No images to show so just finish immediately
        console.warn('Skipping presentation with no images')
        onFinish()
      }
    } else {
      this.loadSlide(0, 0)
    }
  }
  componentWillReceiveProps (nextProps) {
    const { paused } = this.props
    if (paused && !nextProps.paused && this.loadSlideOnPlay) {
      this.loadSlide(this.state.index + 1, 1000)
      this.loadSlideOnPlay = false
    }
  }
  componentWillUnmount () {
    clearTimeout(this.delayTimeout)
    this.mounted = false
  }
  loadSlide (index, delay) {
    const { options, getImageSource, images, count, loadMoreImages, onChangeSlide } = this.props
    const nextImageID = images[index]
    delay = typeof delay !== 'undefined' ? delay : options.transition * 1000

    const delayPromise = new Promise(resolve => {
      this.delayTimeout = setTimeout(resolve, delay)
    })

    const loadPromise = new Promise(resolve => {
      const img = new window.Image()
      img.onload = resolve
      img.onerror = resolve
      img.src = getImageSource(nextImageID, 'p')
    })

    return Promise.all([delayPromise, loadPromise]).then(() => {
      if (!this.mounted) {
        return
      }
      if (this.props.paused) {
        this.loadSlideOnPlay = true
        return
      }
      if (onChangeSlide) {
        onChangeSlide(index)
      }
      this.setState({
        index,
        activeImages: this.state.activeImages.concat({
          id: nextImageID,
          ...this.randomPosition(index)
        })
      })
      const nextIndex = index + 1

      if (images[nextIndex]) {
        this.loadSlide(nextIndex)
      } else {
        if (images.length === count) {
          const { remainingLoops } = this.state
          if (remainingLoops) {
            this.loadSlide(0)
            this.setState({
              remainingLoops: remainingLoops - 1
            })
          } else {
            this.loadSlide(0) // Loop back around by default
          }
        } else {
          loadMoreImages().then(() => this.loadSlide(nextIndex))
        }
      }
    })
  }
  nextSlide () {
    const { images } = this.props
    const { index } = this.state
    if (index < images.length - 1) {
      clearTimeout(this.delayTimeout)
      this.loadSlide(this.state.index + 1, 0)
    }
  }
  prevSlide () {
    // const { index } = this.state
    // if (index > 0) {
    //   clearTimeout(this.delayTimeout)
    //   this.loadSlide(index - 1, 0)
    // }
  }
  onAnimationEnd = () => {
    const { images, count, onFinish } = this.props
    const { activeImages } = this.state
    if (activeImages.length === 1 && images.length === count && onFinish) {
      onFinish()
    } else {
      this.setState({
        activeImages: this.state.activeImages.slice(1)
      })
    }
  }
  randomPosition (index) {
    const { options } = this.props

    // Random left position
    const columns = 3
    const gutter = 10
    const column = index % columns
    const columnSize = (100 - gutter * 2) / columns
    const left = gutter + (column * columnSize) + Math.floor(Math.random() * columnSize) + '%'

    // Random size and speed
    const random = Math.random()
    const width = MIN_WIDTH + (random * (MAX_WIDTH - MIN_WIDTH)) + '%'
    const duration = Math.max(10, Math.round(options.delay + (10 - ((1 - random) * 20))))
    const zIndex = Math.floor(random * 100)
    return { left, width, duration, zIndex }
  }
  render () {
    const { paused, getImageSource } = this.props
    const { activeImages } = this.state

    return (
      <div>
        {activeImages.map(image => {
          const style = {
            animationDuration: `${image.duration}s`,
            animationPlayState: paused ? 'paused' : undefined,
            maxWidth: image.width,
            left: image.left,
            zIndex: image.zIndex
          }
          return (
            <img
              key={image.id}
              className={classNames.image}
              style={style}
              src={getImageSource(image.id, 'p')}
              onAnimationEnd={this.onAnimationEnd}
              onClick={e => this.props.openImageInfo(e, image.id)}
            />
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/present/Floating.js